import React, { useEffect } from "react";
import { Row, Col, Space } from "antd";
import ChartImage1 from "../../../assets/img/rent.png";

const DashPage = () => {
  useEffect(() => {}, []);

  return (
    <Space
      direction="vertical"
      size={32}
      style={{ width: "100%", paddingTop: "0px" }}
    >
      <Row gutter={[32, 32]}>
        <Col lg={{ span: 32 }}>
          <Space direction="vertical" style={{ width: "100%" }} size={32}>
            <div
              style={{
                position: "relative",
                paddingTop: "0%",
              }}
            >
              <img src={ChartImage1} alt="" />
            </div>
          </Space>
        </Col>
      </Row>
    </Space>
  );
};

export default DashPage;
